import { LegalShell } from "../components/LegalShell";
import { useSeo } from "../lib/useSeo";

const Terms = () => {
    useSeo({
        title: "Terms & Conditions | Shillong Morning Teer Result Today",
        description: "Read the Terms and Conditions of using Shillong Morning Teer Result Today. Understand user responsibilities, content rights and limitations of liability.",
        keywords: "shillong morning teer terms, morningteerkhela terms and conditions",
        path: "/terms-and-conditions",
        breadcrumbs: [
            { name: "Home", path: "/" },
            { name: "Terms & Conditions", path: "/terms-and-conditions" },
        ],
    });

    return (
        <LegalShell title="Terms & Conditions" breadcrumb="Terms & Conditions" subtitle="Please read carefully before using the site.">
            <p>
                These Terms &amp; Conditions govern your use of{" "}
                <strong>Shillong Morning Teer Result Today</strong>. By accessing the website you agree
                to be bound by these terms.
            </p>

            <h2>1. Eligibility</h2>
            <p>
                You must be at least 18 years of age (or the legal age of majority in your
                jurisdiction) to view Teer-related content on this website. It is your responsibility
                to comply with any local, state or national laws that apply to you.
            </p>

            <h2>2. Informational Purpose</h2>
            <p>
                All content on this website — including results, previous charts, common numbers,
                dream numbers and direct hit guti — is provided for <em>informational and
                analytical purposes only</em>. We do not operate, promote or facilitate any form of
                betting, gambling, or wagering.
            </p>

            <h2>3. Accuracy of Information</h2>
            <p>
                While we make every effort to display accurate, timely Teer results, small delays or
                data-entry errors may occasionally occur. Always cross-verify the final numbers with
                the official archery club before making any decisions.
            </p>

            <h2>4. User Conduct</h2>
            <ul>
                <li>You will not attempt to disrupt, hack, or reverse-engineer the site.</li>
                <li>You will not scrape or republish our content without written permission.</li>
                <li>You will not use the site to violate any applicable law or third-party right.</li>
            </ul>

            <h2>5. Intellectual Property</h2>
            <p>
                All original text, design, code, logos and layout on this site are the intellectual
                property of Shillong Morning Teer Result Today unless stated otherwise. Result numbers
                themselves are factual data and are not subject to copyright.
            </p>

            <h2>6. Third-Party Links</h2>
            <p>
                We may link to WhatsApp, Telegram or other external services. We do not control those
                sites and are not responsible for their content or policies.
            </p>

            <h2>7. Limitation of Liability</h2>
            <p>
                To the maximum extent permitted by law, we are not liable for any indirect,
                incidental, special or consequential damages resulting from your use of, or reliance
                on, this website.
            </p>

            <h2>8. Termination</h2>
            <p>
                We may suspend or terminate access to the site or specific features at any time
                without notice, particularly in the event of misuse.
            </p>

            <h2>9. Governing Law</h2>
            <p>
                These terms are governed by the laws of India. Any disputes shall be subject to the
                exclusive jurisdiction of the courts of Shillong, Meghalaya.
            </p>

            <h2>10. Changes to these Terms</h2>
            <p>
                We may revise these Terms &amp; Conditions from time to time. Continued use of the
                site after such revisions constitutes your acceptance of the updated terms.
            </p>
        </LegalShell>
    );
};

export default Terms;
